






















































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { ConfigFormData } from '@/models/onboarding';
import { LoyaltyRewardsPayload } from '@/models/sales-onboarding';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import LoyaltyConfigForm from '@/components/organisms/LoyaltyConfigForm/LoyaltyConfigForm.vue';
import RefundConfigForm from '@/components/organisms/RefundConfigForm/RefundConfigForm.vue';
import InfoIcon from '@/components/icons/Info.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import { configFormDataFactory } from '@/views/Onboarding/helpers';

import segmentIo from '@/utils/segment.io';

type KLoyaltyRewards = 'rewardPercentage' | 'refundsLimitDays';

@Component({
  components: {
    Typography,
    LoyaltyConfigForm,
    RefundConfigForm,
    InfoIcon,
    Checkbox
  }
})
export default class LoyaltyProgram extends Vue {
  @Prop() code!: string;
  @Prop() loyaltRewards!: LoyaltyRewardsPayload;
  @Prop({ default: false }) loyaltyWithoutSettings?: boolean;

  status = this.initialStatus;

  data = this.loyaltRewards;

  defaultValues = {
    rewardRatio: [3, 5, 7],
    refundPolicy: [0, 14, 30]
  };

  formData: Record<string, ConfigFormData> = {
    rewardRatio: this.initialFormData(
      this.defaultValues.rewardRatio,
      this.loyaltRewards ? this.loyaltRewards.rewardPercentage : undefined
    ),
    refundPolicy: this.initialFormData(
      this.defaultValues.refundPolicy,
      this.loyaltRewards ? this.loyaltRewards.refundsLimitDays : undefined
    )
  };

  get tPrefix() {
    return 'common.components.loyaltyExampleV2';
  }

  get initialStatus() {
    return !!(
      this.loyaltRewards &&
      (!!this.loyaltRewards.rewardPercentage ||
        !!this.loyaltRewards.refundsLimitDays)
    );
  }

  changeStatus() {
    this.status = !this.status;

    if (!this.status) {
      Object.assign(this.formData.rewardRatio, configFormDataFactory());
      Object.assign(this.formData.refundPolicy, configFormDataFactory());
    }

    this.$store.dispatch('salesOnboarding/SET_FORM_DATA', {
      loyaltyRewards: {
        ...this.data,
        enabled: this.status
      }
    });

    segmentIo.track(
      'Clicked on Toggle Loyalty Program (Ownership experience)',
      {
        status: this.status
      }
    );
  }

  initialFormData(defaultValues: Number[], value?: number) {
    if (value === undefined) return configFormDataFactory();

    const isValidValue = !isNaN(value);

    if (!isValidValue) return configFormDataFactory();

    const valueExistsInDefaultValues = defaultValues.includes(value);

    const type = valueExistsInDefaultValues ? 'default' : 'custom';

    return Object.assign(configFormDataFactory(), {
      value,
      type,
      customValue: !valueExistsInDefaultValues ? value : '',
      state: {
        [value]: true
      }
    });
  }

  handleChangeFormData(key: KLoyaltyRewards, newData: ConfigFormData) {
    const value =
      newData.type === 'custom' ? newData.customValue : newData.value;

    this.data[key] = Number(value);

    this.$store.dispatch('salesOnboarding/SET_FORM_DATA', {
      loyaltyRewards: {
        ...this.data,
        enabled: this.status
      }
    });
  }
}
